export class School {
    Id: number;
    SchoolCode: string;
    SchoolName: string;
    SchoolDescription: string;
    SchoolType: string;
    StudentIds?: number[] = [];
    FamilyCount?: number;
    GradelevelDescription?: string[] = [];
    // FamilyInfo?: FamilyInfo[] = [];
}

export class SchoolStudentFamiliesInfo {
    Parent_ID: number;
    Row_Count: number;
    ParentName: string;
    Student: string;
    StudentNumber: string;
    Grade: string;
    EnrolleDate?: Date;
    BirthDate?: Date;
    SchoolName: string;
    FamilyCount?: number;
    Student_ID: number;
    ParentMem_ID: number;
    Row_Number: number;
}
